import { IconButton, Avatar } from "@material-ui/core";
import MicNoneIcon from "@material-ui/icons/MicNone";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Chat.css";
import { selectChatId, selectChatName, selectChatCreator } from "./features/chatSlice";
import db from "./firebase";
import Message from "./Message";
import firebase from "firebase";
import { selectUser } from "./features/userSlice";
import FlipMove from "react-flip-move";
import "./style.css";

function Chat() {
    const user = useSelector(selectUser);
    const [input, setInput] = useState("");
    const chatName = useSelector(selectChatName);
    const chatCreator = useSelector(selectChatCreator);
    const chatId = useSelector(selectChatId);
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        if (chatId) {
            db.collection("chats")
                .doc(chatId)
                .collection("messages")
                .orderBy("timestamp", "desc")
                .onSnapshot((snapshot) =>
                    setMessages(
                        snapshot.docs.map((doc) => ({
                            id: doc.id,
                            data: doc.data(),
                        }))
                    )
                );
        }
    }, [chatId]);

    const sendMessage = (e) => {
        e.preventDefault();

        db.collection("chats").doc(chatId).collection("messages").add({
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            message: input,
            uid: user.uid,
            photo: user.photo,
            email: user.email,
            displayName: user.displayName,
        });

        setInput("");
    };

    return (
        <div className="chat">
            <div className="chat__header">
                {

                    chatId ? (
                        <>
                            <div className="chat__headerLeft">
                                <Avatar src={`https://avatars.dicebear.com/api/initials/${chatName}.svg?options[chars]=1`} />
                                <h4 className="chat__name">{chatName}</h4>
                            </div>
                            <div className="chat__headerRight">

                                <strong>Created by: {chatCreator}</strong>
                            </div>
                        </>
                    ) : (
                            <>
                                <h3 className="chat__title">iChat | beta | build 1.002.1 | Dev by Arefat</h3>
                            </>
                        )
                }
                {/* <div className="chat__headerLeft">
                    <Avatar src={`https://avatars.dicebear.com/api/initials/${chatName}.svg?options[chars]=1`} />
                    <h4 className="chat__name">{chatName}</h4>
                </div>
                <strong>Created by: {chatCreator}</strong> */}
            </div>


            <div className="chat__messages">
                <FlipMove>
                    {messages.map(({ id, data }) => (
                        <Message key={id} contents={data} />
                    ))}
                </FlipMove>
            </div>

            <div className="chat__input">
                <form>
                    <input
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder={chatId ? ` iChat beta | type your message...` : `Select a Chat or Create a new chat`}
                        type="text"
                        disabled={!chatId}
                    />
                    <button onClick={sendMessage}>Send Message</button>
                </form>

                <IconButton>
                    <MicNoneIcon className="chat__mic" />
                </IconButton>
            </div>
        </div>
    );
}

export default Chat;
